import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const cardStyle = {
  background: "white",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "20px",
  padding: "20px",
  width: "100%",
  textAlign: "center",
};

const titleStyle = {
  fontSize: "18px",
  fontWeight: "bold",
  color: "#333",
  marginBottom: "15px",
};

const chartContainerStyle = {
  height: "240px",
};

const MonthlySelectionTrends = ({ dashboardData }) => {
  const chartRef = useRef(null);

  const dashboardChartData = dashboardData?.monthlyOnboardedCounts;

  const labels = dashboardChartData?.map((item) => item.month);
  const counts = dashboardChartData?.map((item) => item.count);

  const getGradient = () => {
    const chart = chartRef.current;
    if (!chart) return null;

    const { ctx, chartArea } = chart;
    if (!chartArea) return null;

    const gradient = ctx.createLinearGradient(
      0,
      chartArea.top,
      0,
      chartArea.bottom
    );
    gradient.addColorStop(0, "#8472E3");
    gradient.addColorStop(1, "#A3AEFF");
    return gradient;
  };

  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        data: counts,
        backgroundColor: (ctx) => getGradient() || "#8472E3",
        borderRadius: 10,
        borderSkipped: false,
        barPercentage: 0.5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide legend
      },
      title: {
        display: false, // No title
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Hide vertical grid lines
        },
        ticks: {
          color: "#6B7280", // Text color for months
        },
      },
      y: {
        grid: {
          display: false, // Hide horizontal grid lines
          drawBorder: false, // Removes the border line on the Y-axis
        },
        ticks: {
          display: false, // Hide Y-axis labels
        },
      },
    },
  };

  return (
    <div>
      <div style={cardStyle}>
        <h2 style={titleStyle}>Monthly Selection Trends</h2>
        <div style={chartContainerStyle}>
          <Bar ref={chartRef} data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default MonthlySelectionTrends;
